<template>
	<div>
		<div v-if="format === 'large'" class="row align-items-center">
			<div class="col-12 col-lg-8 tw-mb-2 lg:tw-mb-0">
				<div class="image">
					<a :href="post.link" tabindex="-1" class="tw-block tw-relative tw-pb-4/6 tw-group">
						<img v-if="featuredImage.url" v-lazy="featuredImage.url"
							 class="tw-absolute tw-h-full tw-w-full tw-object-cover group-hover:tw-opacity-75" alt="">
						<img v-else v-lazy="'/wp-content/uploads/2020/07/placeholder-test1.png'" class="tw-absolute tw-h-full tw-w-full tw-object-cover group-hover:tw-opacity-75" alt="">
					</a>
				</div>
			</div>
			<div class="col-12 col-lg-4">
				<div class="mb-1">
					<small>
						<a :href="categories[0].link" class="tw-text-gray-600 hover:tw-text-gray-500 text-uppercase tw-transition tw-duration-100" v-html="categories[0].name"> </a>
					</small>
				</div>
				<div>
					<a :href="post.link"
					   class="h5 text-uppercase text-dark font-extrabold" v-html="post.title.rendered"></a>
				</div>
				<div>
					<div v-html="post.excerpt.rendered" class="font-light"></div>
				</div>
				<div>
					<strong class="text-uppercase tk-merriweather small">
						By <a class="tw-text-primary hover:tw-text-gray-500 tw-transition tw-duration-100" :href="author.url" v-html="author.name"></a>
					</strong>
				</div>
			</div>
		</div>
		<div v-else>
			<div class="image tw-mb-2">
				<a :href="post.link" tabindex="-1" class="tw-block tw-relative tw-pb-4/6">
					<img v-if="featuredImage.url" v-lazy="featuredImage.url" class="tw-absolute tw-h-full tw-w-full tw-object-cover" alt="">
					<img v-else v-lazy="'/wp-content/uploads/2020/07/placeholder-test1.png'" class="tw-absolute tw-h-full tw-w-full tw-object-cover" alt="">
				</a>
			</div>
			<div class="tw-clamp-3">
				<small>
					<a :href="categories[0].link" class="tw-text-gray-600 hover:tw-text-gray-700 text-uppercase tw-transition tw-duration-100">
						{{ categories[0].name }}
					</a>
				</small>
				<a :href="post.link"
				   class="text-uppercase text-dark font-extrabold lg:text-1xl leading-extra-snug d-block"
				   v-html="post.title.rendered">
				</a>
			</div>
		</div>
	</div>
</template>


<script>
	import _get from 'lodash.get'
	import _flatten from 'lodash.flatten'

	export default {
		props: {
			post: {
				type: Object,
				required: true,
			},
			format: {
				type: String, // large or simple
				default: 'simple'
			}
		},
		computed: {
			featuredImage() {
			    if (_get(this.post, 'acf.hide_body_images')) {
			        return {
			            url: '/wp-content/uploads/2020/07/placeholder-test1.png'
                    }
                }

				return {
					url: _get(this.post, 'acf.3:2_crop')
				}
			},
			categories() {
				const termsGroupedByTaxonomy = _get(this.post, '_embedded.wp:term', [])
				const terms                  = _flatten(termsGroupedByTaxonomy)

				return terms.filter(term => term.taxonomy === 'category')
			},
			author() {
				return {
					name: _get(this.post, '_embedded.author[0].name'),
					url: _get(this.post, '_embedded.author[0].link'),
				}
			}
		}
	}
</script>
